
// eslint-disable-next-line import/prefer-default-export

/**
 * Change the favicon according to the environment
 * @param string href 
 */
  export const changeFavicon=(href)=> {
    const head = document.head || document.getElementsByTagName('head')[0];
    let date=new Date().getTime();

    const linkElements = document.querySelectorAll("link[rel*='icon']");
    linkElements.forEach(link => link.parentNode.removeChild(link));
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href ='/'+ href+"?v="+date;
    head.appendChild(link);
  }


  /**
 * Check environment (favicon and page title)
 * @param string environment
 */
  export const checkEnvironment=(environment)=> {
    if(environment && environment!=""){
      changeFavicon('favicon'+environment+'.ico');

      if(document.title.startsWith(environment)==false)
        document.title=environment+" - "+document.title;
    }
  }